import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './quote-block-updated.scss.js';
import img from '../../../../assets/images/quote-vector.svg.js';

const LitElementWithUtils = BaseWithUtils(s);
class QuoteUpdatedBlock extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.body = '';
        this.name = '';
        this.position = '';
        this.image = '';
        this.quoteId = '';
        this.sizing = 'default';
        this.altText = '';
    }
    get isRTL() {
        return this.rtl || isRTL();
    }
    get blockClasses() {
        const classes = ['quote-block'];
        if (this.sizing === 'full') {
            classes.push('quote-block--full');
        }
        classes.push(`quote-block--sizing-${this.sizing}`);
        return classes.join(' ');
    }
    render() {
        return $ `<blockquote class="${this.blockClasses}" id="${this.quoteId}" tabindex="0" aria-labelledby="${this.quoteId}-author ${this.quoteId}-position" dir="${this.isRTL ? 'rtl' : 'ltr'}"><div class="quote-block__inner"><p class="quote-block__quote">${o(this.body)}</p><div class="quote-block__source"><div class="quote-block__image-wrapper"><img src="${img}" alt="" class="quote-block__quote-icon" aria-hidden="true"> <img src="${this.image}" alt="${this.altText}" class="quote-block__image" loading="lazy" aria-hidden="true"></div><div class="quote-block__author"><span class="quote-block__name" id="${this.quoteId}-author">${o(this.name)}</span> <span class="quote-block__position" id="${this.quoteId}-position">${o(this.position)}</span></div></div></div></blockquote>`;
    }
}
QuoteUpdatedBlock.styles = [LitElementWithUtils.styles || [], css_248z];
__decorate([
    e({ type: Boolean })
], QuoteUpdatedBlock.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "body", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "name", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "position", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "image", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "quoteId", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "sizing", void 0);
__decorate([
    e({ type: String })
], QuoteUpdatedBlock.prototype, "altText", void 0);
customElements.define('quote-block-updated', QuoteUpdatedBlock);

export { QuoteUpdatedBlock };
